import { useEffect, useState } from "react";

const links = [
  { key: "board", label: "热瓜首屏" },
  { key: "feed", label: "新瓜速递" },
  { key: "track", label: "持续追踪" },
  { key: "rank", label: "热度榜" },
  { key: "pack", label: "打包合集" },
  { key: "faq", label: "常见问题" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-200 ${
        scrolled ? "border-b border-stone-200/70 bg-[#FFF9F1]/90 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        <a href="#board" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-600 text-white">
            <i className="ri-water-flash-line text-lg"></i>
          </span>
          <span className="text-xl font-extrabold tracking-tight text-stone-900">免费吃瓜</span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.key}
              href={`#${l.key}`}
              className="rounded-md px-3 py-2 text-sm text-stone-600 transition-colors hover:bg-emerald-50 hover:text-emerald-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#faq"
          className="hidden whitespace-nowrap rounded-full bg-emerald-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-emerald-700 md:inline-flex"
        >
          <i className="ri-question-line mr-1.5 text-base"></i>了解吃瓜规则
        </a>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-stone-700 md:hidden"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          <span className="sr-only">菜单</span>
        </button>
      </div>

      {open && (
        <nav className="mx-auto flex w-full max-w-6xl flex-col gap-1 border-t border-stone-200/70 bg-[#FFF9F1] px-4 py-3 md:hidden">
          {links.map((l) => (
            <a
              key={l.key}
              href={`#${l.key}`}
              onClick={() => setOpen(false)}
              className="rounded-lg px-3 py-2.5 text-sm text-stone-700 hover:bg-emerald-50"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}